import EnumSet from 'Services/enumSet'

interface IBillingStatus extends EnumSet {
  none: number
  chargedback: number
  refused: number
  authorized: number
  waitingPayment: number
  paid: number
  pendingRefund: number
  refunded: number
  processing: number
  pendingReview: number
  open: number
  cancelled: number
  boletoExpired: number
}

const billingStatus = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  chargedback: { value: 1, description: 'Pagamento estornado' },
  refused: { value: 2, description: 'Pagamento recusado' },
  authorized: { value: 3, description: 'Pagamento autorizado' },
  waitingPayment: { value: 4, description: 'Aguardando pagamento' },
  paid: { value: 5, description: 'Pago' },
  pendingRefund: { value: 6, description: 'Aguardando reembolsado' },
  refunded: { value: 7, description: 'Reembolsado' },
  processing: { value: 8, description: 'Processando' },
  pendingReview: { value: 9, description: 'Aguardando revisão' },
  open: { value: 30, description: 'Aguardando pagamento' },
  cancelled: { value: 31, description: 'Cancelado' },
  boletoExpired: { value: 32, description: 'Boleto vencido' },
}) as IBillingStatus

export default billingStatus